<template>
  <footer>
    <div id="footer-main">Hundia Infotec</div>

    <div id="footer-detail">
      #73/1, 3rd Main, Conservancy Road between 4th &amp; 5th Cross, Chamrajpet,
      Bangalore-560018
    </div>

    <div id="footer-links">
      <a
        href="https://www.facebook.com/"
        target="_blank"
        id="facebook"
        class="social-media"
      >
        <img alt="facebook icon" src="@/assets/icons/facebook.svg" />
      </a>

      <a
        href="https://api.whatsapp.com/send?phone=+917305605306"
        target="_blank"
        id="whatsapp"
        class="social-media"
      >
        <img alt="whatsapp icon" src="@/assets/icons/whatsapp.svg" />
      </a>

      <a
        href="mailto:hundia.infotec@gmail.com"
        data-type="mail"
        target="_blank"
        id="mail"
        class="social-media"
        ><img alt="mail icon" src="@/assets/icons/mail.svg" />
      </a>
    </div>

    <div id="footer-copyright">©2022 Hundia Infotec</div>
  </footer>
</template>

<script></script>

<style scoped>
.social-media img {
  margin: 0;
  width: 20px;
  height: 20px;
  display: inline-block;
  object-fit: cover;

  filter: invert(11%) sepia(35%) saturate(2850%) hue-rotate(191deg)
    brightness(99%) contrast(91%);
}

#facebook:hover > img,
#facebook:active > img {
  filter: invert(37%) sepia(71%) saturate(4108%) hue-rotate(204deg)
    brightness(99%) contrast(92%);
}

#whatsapp:hover > img,
#whatsapp:active > img {
  filter: invert(89%) sepia(78%) saturate(1439%) hue-rotate(64deg)
    brightness(87%) contrast(90%);
}

#mail:hover > img,
#mail:active > img {
  filter: invert(56%) sepia(84%) saturate(6576%) hue-rotate(345deg)
    brightness(99%) contrast(86%);
}

footer {
  text-align: center;
  font-size: 1em;
  font-weight: normal;
  font-family: "avenir";
  font-kerning: auto;
}

footer #footer-main {
  margin: 0 auto;
  text-align: center;
  font-family: times;
  font-size: 1.4em;

  margin-bottom: 1em;
  padding-top: 3em;
  padding-bottom: 1em;
}

footer #footer-detail {
  margin: 0 auto;
  text-align: center;
  font-size: 0.85em;
  width: 100%;
  height: auto;
  margin-top: 1em;
  margin-bottom: 1em;
  padding-bottom: 1em;
}

footer a:link {
  text-decoration: none;
}

footer #footer-links {
  display: flex;
  align-content: center;
  justify-content: center;
  flex-direction: row;
  gap: 1em;
}

footer #footer-copyright {
  font-size: 0.85em;
  margin-top: 1em;
}
</style>
